export default "__VITE_ASSET__BSqp3CZC__"